<template>
  <div>
    <h2>Page Not Found</h2>
    <p>Oops, the page you're looking is missing or doesn't exist. <a href="/">Return to the home page</a>.</p>
  </div>
</template>

<script>
  export default {
    name: 'notfound',

    metaInfo: {
      title: "Not Found",
      titleTemplate: "%s | Contrology | Balanced Body",
      meta: [
        {
          name: 'robots',
          content: 'noindex, nofollow'
        },
        {
          property: "og:image",
          content: "https://s3.amazonaws.com/s3.pilates.com/contrology/contrology-default.jpg"
        }
      ]
    }
  }
</script>

<style lang="scss" scoped>
div {
  text-align: center;
}

a {
  color: var(--black);
}
</style>